import React from "react";
import LoginCreative from "./Components/Login/LoginCreative";
import ResetCreative from "./Components/Login/ResetCreative";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import Role from "./Components/Role/Role";
import RoleList from "./Components/Role/RoleList";
import EditRole from "./Components/Role/EditRole";
import State from "./Components/State/State";
import EditState from "./Components/State/EditState";
import StateList from "./Components/State/StateList";
import District from "./Components/District/District";
import DistrictList from "./Components/District/DistrictList";
import EditDistrict from "./Components/District/EditDistrict";
import EditCity from "./Components/City/EditCity";
import City from "./Components/City/City";
import CityList from "./Components/City/CityList";
import EditBranch from "./Components/Branch/EditBranch";
import BranchList from "./Components/Branch/BranchList";
import Branch from "./Components/Branch/Branch";
import User from "./Components/User/User";
import EditUser from "./Components/User/EditUser";
import UserList from "./Components/User/UserList";
import PermissionList from "./Components/Permission/PermissionList";
import Loan_Inquiry from "./Components/Loan_Inquiry/Loan_Inquiry";
import Loan_InquiryList from "./Components/Loan_Inquiry/Loan_InquiryList";
import EditLoan_Inquiry from "./Components/Loan_Inquiry/EditLoan_Inquiry";
import Loan_Schemes from "./Components/Loan_Schemes/Loan_Schemes";
import Loan_SchemesList from "./Components/Loan_Schemes/Loan_SchemesList";
import EditLoan_Schemes from "./Components/Loan_Schemes/EditLoan_Schemes";
import Bank from "./Components/Bank/Bank";
import BankList from "./Components/Bank/BankList";
import EditBank from "./Components/Bank/EditBank";
import Loan_TypeList from "./Components/Loan_Type/Loan_TypeList";
import Loan_Type from "./Components/Loan_Type/Loan_Type";
import EditLoan_Type from "./Components/Loan_Type/EditLoan_Type";
import Loan_Inquiry_Status from "./Components/Loan_Inquiry_Status/Loan_Inquiry_Status";
import Loan_Inquiry_StatusList from "./Components/Loan_Inquiry_Status/Loan_Inquiry_StatusList";
import EditLoan_Inquiry_Status from "./Components/Loan_Inquiry_Status/EditLoan_Inquiry_Status";
import Lead_Source from "./Components/Lead_Source/Lead_Source";
import Lead_SourceList from "./Components/Lead_Source/Lead_SourceList";
import EditLead_Source from "./Components/Lead_Source/EditLead_Source";
import LeadPayment from "./Components/LeadPayment/LeadPayment";
import LeadPaymentList from "./Components/LeadPayment/LeadPaymentList";
import EditLeadPayment from "./Components/LeadPayment/EditLeadPayment";
import Task from "./Components/Task/Task";
import TaskList from "./Components/Task/TaskList";
import EditTask from "./Components/Task/EditTask";
import Expense from "./Components/Expense/Expense";
import ExpenseList from "./Components/Expense/ExpenseList";
import EditExpense from "./Components/Expense/EditExpense";
import EditExpense_Category from "./Components/Expense_Category/EditExpense_Category";
import Expense_CategoryList from "./Components/Expense_Category/Expense_CategoryList";
import Expense_Category from "./Components/Expense_Category/Expense_Category";
import Notes from "./Components/Notes/Notes";
import EditNotes from "./Components/Notes/EditNotes";
import NotesList from "./Components/Notes/NotesList";
import Notetype from "./Components/Notetype/Notetype";
import NotetypeList from "./Components/Notetype/NotetypeList";
import EditNotetype from "./Components/Notetype/EditNotetype";
import TaskStatus from "./Components/Task_Status/TaskStatus";
import EditTaskStatus from "./Components/Task_Status/EditTaskStatus";
import TaskStatusList from "./Components/Task_Status/TaskStatusList";
import TaskCategoryList from "./Components/Task_Category/TaskCategoryList";
import EditTaskCategory from "./Components/Task_Category/EditTaskCategory";
import TaskCategory from "./Components/Task_Category/TaskCategory";
import TaskHistory from "./Components/Task/TaskHistory";
import SettledList from "./Components/Settled/SettledList";
import SettledAdd from "./Components/Settled/SettledAdd";
import Member from "./Components/Member/Member";
import MemberList from "./Components/Member/MemberList";
import EditMember from "./Components/Member/EditMember";
import ViewMember from "./Components/Member/ViewMember";
import Lead_upload from "./Components/Leads/Lead_upload";
import UserHeirarchy from "./Components/User/UserHeirarchy";
import OpenLoanLeadsList from "./Components/OpenLoanLeads/OpenLoanLeadsList";
import ChangePassword from "./Components/Login/ChangePassword";
import Profile from "./Components/Company/Profile";
import Prefix from "./Components/Company/Prefix";
import ExpenseHistory from "./Components/Expense/ExpenseHistory";
import Loan_InquiryHistory from "./Components/Loan_Inquiry/Loan_InquiryHistory";
import OpenLoanLeadsHistory from "./Components/OpenLoanLeads/OpenLoanLeadsHistory";
import SettledHistory from "./Components/Settled/SettledHistory";
import Assigned_Lead from "./Components/Leads/Assigned_Leads";
import LeadStage from "./Components/Home/LeadStage";
import Reports from "./Components/Reports/Reports";
import UserProfile from "./Components/Company/UserProfile";
import Income_Reports from "./Components/Reports/Income_Rreports";
import UnassignedList from "./Components/Unassigned/UnassignedList";
import Email from "./Components/Company/Email";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginCreative />} />
        <Route path="/reset-password" element={<ResetCreative />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/home" element={<Home />} />
        {/* Role */}
        <Route path="/master/add-role" element={<Role />} />
        <Route path="/master/role-list" element={<RoleList />} />
        <Route path="/master/edit-role/:id" element={<EditRole />} />

        {/* State */}
        <Route path="/master/add-state" element={<State />} />
        <Route path="/master/state-list" element={<StateList />} />
        <Route path="/master/edit-state/:id" element={<EditState />} />

        {/* District */}
        <Route path="/master/add-district" element={<District />} />
        <Route path="/master/district-list" element={<DistrictList />} />
        <Route path="/master/edit-district/:id" element={<EditDistrict />} />

        {/* City */}
        <Route path="/master/add-city" element={<City />} />
        <Route path="/master/city-list" element={<CityList />} />
        <Route path="/master/edit-city/:id" element={<EditCity />} />

        {/* Loan_Inquiry_Status */}
        <Route
          path="/master/add-inquiry-status"
          element={<Loan_Inquiry_Status />}
        />
        <Route
          path="/master/inquiry-status-list"
          element={<Loan_Inquiry_StatusList />}
        />
        <Route
          path="/master/edit-inquiry-status/:id"
          element={<EditLoan_Inquiry_Status />}
        />

        {/* Lead_Source */}
        <Route path="/master/inquiry-add-sources" element={<Lead_Source />} />
        <Route
          path="/master/inquiry-sources-list"
          element={<Lead_SourceList />}
        />
        <Route
          path="/master/inquiry-edit-sources/:id"
          element={<EditLead_Source />}
        />

        {/* Bank */}
        <Route path="/master/add-lender" element={<Bank />} />
        <Route path="/master/lender-list" element={<BankList />} />
        <Route path="/master/edit-lender/:id" element={<EditBank />} />

        {/* Branch */}
        <Route path="/master/add-branch" element={<Branch />} />
        <Route path="/master/branch-list" element={<BranchList />} />
        <Route path="/master/edit-branch/:id" element={<EditBranch />} />

        {/* Loan_Type */}
        <Route path="/master/add-inquiry-type" element={<Loan_Type />} />
        <Route path="/master/inquiry-type-list" element={<Loan_TypeList />} />
        <Route
          path="/master/edit-inquiry-type/:id"
          element={<EditLoan_Type />}
        />

        {/* Expense */}
        <Route path="/master/add-expense" element={<Expense />} />
        <Route path="/master/expense-list" element={<ExpenseList />} />
        <Route path="/master/edit-expense/:id" element={<EditExpense />} />

        {/* Expense Catagory */}
        <Route
          path="/master/add-expense-category"
          element={<Expense_Category />}
        />
        <Route
          path="/master/expense-category-list"
          element={<Expense_CategoryList />}
        />
        <Route
          path="/master/edit-expense-category/:id"
          element={<EditExpense_Category />}
        />
        <Route path="/expense/history/:id" element={<ExpenseHistory />} />

        {/* Notes */}
        <Route path="/master/add-notes" element={<Notes />} />
        <Route path="/master/notes-list" element={<NotesList />} />
        <Route path="/master/edit-notes/:id" element={<EditNotes />} />

        {/* Notes */}
        <Route path="/master/add-note-type" element={<Notetype />} />
        <Route path="/master/note-type-list" element={<NotetypeList />} />
        <Route path="/master/edit-note-type/:id" element={<EditNotetype />} />

        {/* {Task Status} */}
        <Route path="/task/add-task-status" element={<TaskStatus />} />
        <Route path="/task/task-status-list" element={<TaskStatusList />} />
        <Route path="/task/edit-task-status/:id" element={<EditTaskStatus />} />
        {/* {Task Category} */}
        <Route path="/task/add-task-category" element={<TaskCategory />} />
        <Route path="/task/task-category-list" element={<TaskCategoryList />} />
        <Route
          path="/task/edit-task-category/:id"
          element={<EditTaskCategory />}
        />

        {/* Permission */}
        <Route path="/master/manage-permission" element={<PermissionList />} />

        {/* User */}
        <Route path="/employee/add-employee" element={<User />} />
        <Route path="/employee/employee-list" element={<UserList />} />
        <Route path="/employee/edit-employee/:id" element={<EditUser />} />
        <Route
          path="/employee/employee-hierarchy"
          element={<UserHeirarchy />}
        />

        {/* Loan_Inquiry */}
        <Route path="/inquiry/add-inquiry" element={<Loan_Inquiry />} />
        <Route path="/inquiry/inquiry-list" element={<Loan_InquiryList />} />
        <Route
          path="/inquiry/edit-inquiry/:id"
          element={<EditLoan_Inquiry />}
        />
        <Route
          path="/inquiry-converted/history/:id"
          element={<OpenLoanLeadsHistory />}
        />
        <Route
          path="/inquiry-settled/history/:id"
          element={<SettledHistory />}
        />
        <Route path="/inquiry/history/:id" element={<Loan_InquiryHistory />} />
        <Route path="/inquiry/settled-list" element={<SettledList />} />
        <Route path="/inquiry/settled-add" element={<SettledAdd />} />
        <Route
          path="/inquiry/converted-inquiry-list"
          element={<OpenLoanLeadsList />}
        />

        {/* Loan_Schemes */}
        <Route path="/loan/add-loan-schemes" element={<Loan_Schemes />} />
        <Route path="/loan/loan-schemes-list" element={<Loan_SchemesList />} />
        <Route
          path="/loan/edit-loan-schemes/:id"
          element={<EditLoan_Schemes />}
        />

        {/* Loan_Schemes */}
        <Route path="/payout/add-inquiry-payment" element={<LeadPayment />} />
        <Route
          path="/payout/inquiry-payment-list"
          element={<LeadPaymentList />}
        />
        <Route
          path="/payout/edit-inquiry-payment/:id"
          element={<EditLeadPayment />}
        />
        <Route path="/assigned-inquiry" element={<Assigned_Lead />} />
        <Route path="/leadstage/:id" element={<LeadStage />} />
        {/* Member */}
        <Route path="/member/add-member" element={<Member />} />
        <Route path="/member/member-list" element={<MemberList />} />
        <Route path="/member/edit-member/:id" element={<EditMember />} />
        <Route path="/member/view-member/:id" element={<ViewMember />} />

        {/* Leads */}

        <Route path="/inquiry/bulk-inquiry-upload" element={<Lead_upload />} />
        {/* Reset */}
        <Route path="/reset" element={<District />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route
          path="/company/company-configration-update"
          element={<Profile />}
        />
        <Route
          path="/company/prefix-configration-update"
          element={<Prefix />}
        />
        <Route path="/company/email-configration-update" element={<Email />} />
        {/* Task */}
        <Route path="/task/add-task" element={<Task />} />
        <Route path="/task/task-list" element={<TaskList />} />
        <Route path="/task/edit-task/:id" element={<EditTask />} />
        <Route path="/task/history/:id" element={<TaskHistory />} />
        {/* Reports */}

        <Route path="/reports/inquiry-reports" element={<Reports />} />
        <Route path="/reports/income-reports" element={<Income_Reports />} />

        {/* Unassigned */}

        <Route path="/un-assigned-inquiry" element={<UnassignedList />} />
      </Routes>
    </>
  );
};

export default App;
